export default ({ width = "10px", height = "10px", stroke = "#fff" }: any) => (
  <svg width={width} height={height} stroke={stroke} viewBox="0 0 10 8" version="1.1">
    <g
      id="Page-1"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <g transform="translate(-375.000000, -305.000000)" strokeWidth="1.4">
        <g id="Group-3" transform="translate(24.000000, 296.000000)">
          <g id="checked" transform="translate(346.000000, 3.000000)">
            <polyline id="Path" points="14 7 8.84615385 13 6 10.2017982" />
          </g>
        </g>
      </g>
    </g>
  </svg>
);
